import { CommentTargetTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { CommentTargetType } from '@/services/graphql/types';

export const mapperToCommentTargetType = createEnumMapperFunction(
  CommentTargetTypeDataEnum,
  CommentTargetType
);
